import axios from 'axios';
import { ErrorType, recordError } from '../models/apiWrappers/api/exceptions';

export const identifyLead = async ({
  email,
  segmentAnonymousId,
}: {
  email: string;
  segmentAnonymousId: string;
}): Promise<void> => {
  try {
    await axios.post(
      `${process.env.REACT_APP_VERCEL_URL}/v1/leads/identify`,
      {
        email,
        anonId: segmentAnonymousId,
      },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
  } catch (err) {
    recordError(ErrorType.HANDLED, 'vercel api - failed to identify lead', { err });
  }
};
